import { Link } from 'react-router-dom';
import { matches } from '@/mocks/homeData';

export default function MatchesSection() {
  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-8 md:mb-10">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
              赛事资讯
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              热门赛事
            </h2>
          </div>
          <Link
            to="/category/live"
            className="mt-3 sm:mt-0 flex items-center gap-1 text-primary-600 hover:text-primary-700 text-sm font-medium transition-colors whitespace-nowrap"
          >
            查看全部赛事
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {matches.map((match) => (
            <div
              key={match.id}
              className="p-5 md:p-6 rounded-2xl bg-background-100 hover:bg-background-200/70 transition-all duration-300"
            >
              <div className="flex items-center justify-between mb-4">
                <span className="text-xs font-medium text-foreground-500 bg-background-50 px-3 py-1 rounded-full">
                  {match.league}
                </span>
                <span
                  className={`text-xs font-medium px-2.5 py-1 rounded-full ${
                    match.status === '已结束'
                      ? 'bg-foreground-100 text-foreground-600'
                      : 'bg-accent-100 text-accent-700'
                  }`}
                >
                  {match.status}
                </span>
              </div>

              <div className="flex items-center justify-between mb-4">
                <div className="text-center flex-1">
                  <p className="font-heading text-sm md:text-base font-semibold text-foreground-900">
                    {match.homeTeam}
                  </p>
                </div>
                <div className="px-3">
                  {match.homeScore !== null ? (
                    <span className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                      {match.homeScore} - {match.awayScore}
                    </span>
                  ) : (
                    <span className="font-heading text-lg font-semibold text-foreground-400">
                      VS
                    </span>
                  )}
                </div>
                <div className="text-center flex-1">
                  <p className="font-heading text-sm md:text-base font-semibold text-foreground-900">
                    {match.awayTeam}
                  </p>
                </div>
              </div>

              <div className="flex items-center justify-center gap-1.5 text-foreground-500 text-xs">
                <i className={`${match.icon} text-xs`}></i>
                <span>{match.time}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}